import Factsheet from "./components/Factsheet";
import Header from "./components/Header";
import FoodSearch from "./components/FoodSearch"
import { usePath } from "./libs/path/PathProvider";
import { useEffect, useState } from "react";
import Loading from "./libs/loading/Loading";
import Foods from "./data/Foods"
import Nuts from "./data/Nutrients";
import RecipeSearch from "./components/RecipeSearch";
import FoodTabs from "./components/FoodTabs";
import FoodUtils from "./utils/FoodUtils";
import { combineClass } from "./libs/GWidget";
import Recipes from "./pages/Recipes";
import Factsheets from "./pages/Factsheets";
import useLogin from "./libs/login/useLogin";
import { useDialog } from "./libs/dialog/DialogProvider";
import AddRecipe from "./components/AddRecipe";
import Settings from "./components/Settings";

export default function App(){
    const {path,setPath} = usePath()
    const [ready,setReady] = useState<boolean>(false)
    const [scroll,setScroll] = useState<boolean>(false)
    const {isLoggedIn, login} = useLogin()
    const {openDialog} = useDialog()

    useEffect(() => {
        Promise.all([Foods.i.get(),Nuts.i.get()]).then(() => setReady(true))
    }, [])

    const onSearch = (id:number) => setPath(`/search/${id}`)
    const onAdd = () => {
        if (!isLoggedIn) return login(onAdd)
        switch(FoodUtils.getPage(path)){
        case "home":    openDialog({id:"addrecipe",children:<AddRecipe/>}); break;
        }
    }
    const onScroll = (e:any) => setScroll(e.target.scrollTop>0)
    
    let toolbar:React.ReactElement|null = null
    let content:React.ReactElement|null = null
    if (ready) {
        switch(FoodUtils.getPage(path)){
        case "home":
            toolbar = <RecipeSearch className={combineClass({scroll})}/>
            content = <Recipes/>
            break;
        case "search":
            toolbar = <FoodSearch onSearch={onSearch} className={combineClass({scroll})}/>
            content = <Factsheets/>
            break;
        case "settings":
            content = <Settings/>
            break;
        default: 
            setPath("/home")
        }
    }
    else content = <Loading/>
    return <>
        <Header onAdd={onAdd}/>
        {toolbar}
        <div className="content flex1" onScroll={onScroll}>{content}</div>
        <FoodTabs/>
    </>
}